import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { applicationsApi } from '@/features/applications/api/applications.api'

const LIST_KEY = ['student', 'applications'] as const

export function useStudentApplications() {
  return useQuery({ queryKey: LIST_KEY, queryFn: applicationsApi.list })
}

export function useStudentApplication(id: number) {
  return useQuery({
    queryKey: ['student', 'applications', id],
    queryFn: () => applicationsApi.get(id),
  })
}

export function useApplyToJob() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: applicationsApi.apply,
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({ queryKey: LIST_KEY })
      void queryClient.invalidateQueries({ queryKey: ['student', 'jobs', variables.jobId] })
    },
  })
}

export function useWithdrawApplication() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: applicationsApi.withdraw,
    onSuccess: (result) => {
      void queryClient.invalidateQueries({ queryKey: LIST_KEY })
      void queryClient.invalidateQueries({ queryKey: ['student', 'applications', result.id] })
    },
  })
}
